<template>
  <div style="margin-top:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Manage Support Tickets</span><br/>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-right: 10px">
        create, view and update support tickets
      </div>
    </div>

    <b-modal title="Here are details on the statuses and filters used for the VSM" size="lg" v-model="view_more_info" ok-only>
      <br/>
      Use this page to view and manage support tickets.
      <br/><br/>
      <b>Create A Support Ticket</b>
      <br/><br/>
      Click 'Create Ticket' to get started with a new ticket
      <br/><br/>
      <b>Search For A Support Ticket</b>
      <br/><br/>
      Use the search tools to find existing tickets
      <br/><br/>
      <b>Update A Support Ticket</b>
      <br/><br/>
      Click the Edit Icon to update a ticket

    </b-modal>

      <div style="font-size: 18px; font-weight: bold; position: relative; margin: 20px 0px 20px 0px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)">&lt;</a>
      &nbsp;<date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">&gt;</a>
      &nbsp;&nbsp;Priority:&nbsp;<b-form-select v-model="selected_priority" :options="priority_options" style="font-size: 18px; font-weight: bold; width:180px"/>
      &nbsp;&nbsp;Category:&nbsp;<b-form-select v-model="selected_category" :options="category_options" style="font-size: 18px; font-weight: bold; width:200px"/>
      &nbsp;&nbsp;Status:&nbsp;<b-form-select v-model="selected_status" :options="status_options" style="font-size: 18px; font-weight: bold; width:220px"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data">Search</b-button>
      &nbsp;&nbsp;<b-button variant="success" size="md" :to="{ name: 'support_ticket_create' }"><span style="color:white">Create Ticket</span></b-button>
    </div>
    <div v-if="user.role === 'admin'" style="font-size: 18px; font-weight: bold; position: relative; margin: 20px 0px 20px 0px" class="d-flex align-items-center justify-content-center">
      Results: {{items.length}} of {{items_full.length}}
<!--      &nbsp;&nbsp;|&nbsp;&nbsp;Est Hrs: {{estimated_hrs}}-->
<!--      &nbsp;&nbsp;|&nbsp;&nbsp;Act Hrs: {{total_actual_hrs}}-->
      &nbsp;|&nbsp;&nbsp;Customer:&nbsp;<b-form-select v-model="selected_tenant" style="font-size: 18px; font-weight: bold; width:250px" :options="search_tenant_options"/>
      &nbsp;&nbsp;Assigned:&nbsp;<b-form-select v-model="selected_assigned" :options="assigned_options" style="font-size: 18px; font-weight: bold; width:150px"/>
      &nbsp;&nbsp;<b-form-input style="font-size: 18px; width: 150px" v-model="search_text" placeholder="subject text"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="show_my_active">Act</b-button>
      &nbsp;&nbsp;<b-button v-on:click.prevent="show_my_review">Rev</b-button>
      &nbsp;&nbsp;<b-button v-on:click.prevent="show_my_open">Open</b-button>
      &nbsp;&nbsp;<b-button v-on:click.prevent="show_my_waiting">Wait</b-button>
      &nbsp;&nbsp;<b-button v-on:click.prevent="show_unassigned">Unassgnd</b-button>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button v-on:click.prevent="show_active('ben')">Ben</b-button>
      &nbsp;<b-button v-on:click.prevent="show_active('jen')">Jen</b-button>
      &nbsp;<b-button v-on:click.prevent="show_active('chaz')">Chz</b-button>
      &nbsp;<b-button v-on:click.prevent="show_active('kai')">Kai</b-button>
      &nbsp;&nbsp;|&nbsp;<b-button v-on:click.prevent="show_all_open">All</b-button>
      &nbsp;<b-button v-on:click.prevent="show_all_current_account">Cust</b-button>
    </div>

    <div style="margin:20px">
      <b-table :busy="loading"
               sticky-header="70vh"
               bordered
               :items="items"
               :fields="filteredFields"
               :current-page="currentPage"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="id" slot-scope="row">
          <router-link :to="{ path: 'support_ticket_details?tenant_id=' + row.item.tenant_id + '&id=' + row.item.id}">
            {{ row.item.id }}
          </router-link>
        </template>

        <template slot="tenant_id" slot-scope="row">
          {{getOptionText(user.tenant_options, row.item.tenant_id)}}
        </template>

        <template slot="estimated_hours" slot-scope="row">
          <span v-if="row.item.estimated_hours">
            {{ row.item.estimated_hours }} hrs (${{150 * Number(row.item.estimated_hours)}})
          </span>
        </template>

        <template slot="actual_hours" slot-scope="row">
          <span v-if="row.item.actual_hours">
            {{ row.item.actual_hours }} hrs (${{150 * Number(row.item.actual_hours)}})
          </span>
        </template>

        <template slot="created_at" slot-scope="row">
          {{ row.item.created_at | formatDateTimeSmall }}
        </template>

        <template slot="updated_at" slot-scope="row">
          <span v-if="row.item.updated_at_overdue" style="color: darkred">{{ row.item.updated_at | formatDateTimeSmall }}</span>
          <span v-else>{{ row.item.updated_at | formatDateTimeSmall }}</span>
        </template>

        <template slot="assigned_to" slot-scope="row">
          {{getOptionText(assigned_options, row.item.assigned_to)}}
        </template>

        <template slot="username" slot-scope="row">
          {{row.item.username.split('@')[0]}}
        </template>

        <template slot="updated_by" slot-scope="row">
          <span v-if="row.item.updated_at && getOptionText(assigned_options, row.item.updated_by) != row.item.updated_by">
            {{getOptionText(assigned_options, row.item.updated_by)}}
          </span>
          <span v-else-if="row.item.updated_by">{{row.item.updated_by.split('@')[0]}}</span>
        </template>

        <template slot="ticket_status" slot-scope="row">
          {{getOptionText(status_options, row.item.ticket_status)}}
        </template>
        <template slot="priority" slot-scope="row">
          {{getOptionText(priority_options, row.item.priority)}}
        </template>
        <template slot="category" slot-scope="row">
          {{getOptionText(category_options, row.item.category)}}
        </template>

        <template slot="actions" slot-scope="row">
          <template>
            <router-link :to="{ path: 'support_ticket_details?tenant_id=' + row.item.tenant_id + '&id=' + row.item.id}">
              <img src="/edit.png" alt="Edit" style="height: 1rem; margin: 5px; text-align: center !important; cursor: pointer"/>
            </router-link>
              <img src="/delete.png" alt="Delete" style="height: 1.25rem; margin: 5px; text-align: center !important; cursor: pointer" @click="delete_support_ticket(row.item.tenant_id,row.item.id)"/>
          </template>
        </template>
      </b-table>

      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>
  import { delete_support_ticket, search_support_tickets } from '../networking/apis'
  import { mapState } from "vuex";
  import { justDate } from "@/helpers/dates";
  import moment from "moment/moment";

  export default {
    name: 'support_ticket_list',
    data() {
      return {
        toggle: {},
        view_more_info: false,
        auto_reload: true,
        file: null,
        msg: 'support_ticket_list',
        items: [],
        items_full: [],
        selected_assigned: '',
        selected_tenant: '',
        selected_category: '',
        selected_priority: '',
        search_text: '',
        selected_status: 'open',
        summary: [],
        loading: true,
        totalRows: 1,
        currentPage: 1,
        perPage: 100,
        pages: [],
        details_fromDate: justDate(moment().subtract(6, 'month')),
        details_toDate: justDate(moment()),
        assigned_options: [
          {value: '', text: 'All'},
          {value: 'unassigned', text: 'Unassigned'},
          { value: 'ben@initekconsulting.com', text: 'Ben ODay' },
          { value: 'jen@initekconsulting.com', text: 'Jen Mayer' },
          { value: 'chaz@initekconsulting.com', text: 'Chaz Watson' },
          { value: 'kai@initekconsulting.com', text: 'Kai Klein' },
          { value: 'evan@initekconsulting.com', text: 'Evan Anderson' },
        ],
        category_options: [
          {value: '', text: 'All'},
          {value: 'general', text: 'General'},
          {value: 'actuals', text: 'Actuals'},
          {value: 'alerts', text: 'Alerts'},
          {value: 'maps', text: 'Map Views'},
          {value: 'reports', text: 'View & Reports'},
          {value: 'vsm', text: 'Vehicle Status Manager'},
          {value: 'data', text: 'Data Services'},
          {value: 'fleet-assistant', text: 'Fleet Assistant'},
        ],
        priority_options: [
          {value: '', text: 'All'},
          {value: 'question', text: 'Question/Request'},
          {value: 'minor', text: 'Minor Bug'},
          {value: 'urgent', text: 'Major Bug / System Issue'},
          {value: 'enhancement', text: 'Enhancement Request'},
          {value: 'feature', text: 'New Feature Request'},
        ],
        status_options: [
          { value: 'open', text: 'Open'},
          { value: '', text: 'All'},
          { value: 'active', text: 'Active'},
          { value: 'review', text: 'Under Review' },
          { value: 'new', text: 'New' },
          { value: 'queued', text: 'Queued' },
          { value: 'progress', text: 'In Progress' },
          { value: 'waiting', text: 'Waiting On Customer' },
          { value: 'approved', text: 'Customer Approved' },
          { value: 'testing', text: 'Customer Testing' },
          { value: 'cancelled', text: 'Cancelled' },
          { value: 'completed', text: 'Completed' },
        ],
        options: {
          format: 'MM-DD-YYYY',
          useCurrent: true,
          minDate: moment().subtract(360, 'days'),
          maxDate: moment().add(0, 'days'),
          keepOpen: false,
          showClear: true,
          showClose: true,
          toolbarPlacement: 'top',
        },
        fields: [
          { key: 'id', label: 'ID', sortable: true },
          { key: 'tenant_id', label: 'Account', sortable: true, thStyle: { width: "200px" } },
          { key: 'subject', sortable: true, thStyle: { width: "250px" } },
          { key: 'ticket_status', label: 'Status', sortable: true },
          { key: 'priority', sortable: true },
          { key: 'category', label: 'Feature', sortable: true },
          { key: 'username', label: 'Created By', sortable: true },
          { key: 'created_at', label: 'Created At', sortable: true },
          { key: 'updated_by', label: 'Updated By', sortable: true },
          { key: 'updated_at', label: 'Updated At', sortable: true },
          { key: 'assigned_to', label: 'Assigned To', sortable: true },
          { key: 'estimated_hours', label: 'Estimated Dev', sortable: true },
          { key: 'actual_hours', label: 'Actual Dev', sortable: true },
          { key: 'estimated_finish_date', label: 'Target Date', sortable: true },
          { key: 'actions', label: 'Actions' },
        ],
      }
    },

    async created() {
      this.selected_tenant = this.user.tenant

      this.load_filters()

      await this.load_data()
    },

    methods: {
      show_my_active() {
        this.items = this.items_full
        this.selected_tenant = ''
        this.selected_assigned = this.user.username
        this.selected_status = 'active'
        this.load_data()
      },
      show_my_review() {
        this.items = this.items_full
        this.selected_tenant = ''
        this.selected_assigned = this.user.username
        this.selected_status = 'review'
        this.load_data()
      },
      show_active(user) {
        this.items = this.items_full
        this.selected_tenant = ''
        this.selected_assigned = user + '@initekconsulting.com'
        this.selected_status = 'active'
        this.load_data()
      },
      show_my_open() {
        this.items = this.items_full
        this.selected_tenant = ''
        this.selected_assigned = this.user.username
        this.selected_status = 'open'
        this.load_data()
      },
      show_my_waiting() {
        this.items = this.items_full
        this.selected_tenant = ''
        this.selected_assigned = this.user.username
        this.selected_status = 'waiting'
        this.load_data()
      },
      show_unassigned() {
        this.items = this.items_full
        this.selected_tenant = ''
        this.selected_status = 'open'
        this.selected_assigned = 'unassigned'
        this.load_data()
      },
      show_all_open() {
        this.items = this.items_full
        this.selected_tenant = ''
        this.selected_status = 'open'
        this.selected_assigned = ''
        this.load_data()
      },
      show_all_current_account() {
        this.items = this.items_full
        this.selected_tenant = this.user.tenant
        this.selected_status = 'open'
        this.selected_assigned = ''
        this.load_data()
      },
      save_filters() {
        let filters = {
          "details_fromDate": this.details_fromDate,
          "details_toDate": this.details_toDate,
          "selected_tenant": this.selected_tenant,
          "selected_status": this.selected_status,
          "selected_assigned": this.selected_assigned,
          "selected_category": this.selected_category,
          "selected_priority": this.selected_priority
        }
        localStorage.setItem('support-filters', JSON.stringify(filters))
      },
      load_filters() {
        let support_filters = localStorage.getItem('support-filters')
        if (support_filters) {
          this.auto_reload = false
          let support_filters_dict = JSON.parse(support_filters)
          if (support_filters_dict.details_fromDate) {
            this.details_fromDate = support_filters_dict.details_fromDate
            this.details_toDate = support_filters_dict.details_toDate
          }
          this.selected_tenant = support_filters_dict.selected_tenant
          this.selected_status = support_filters_dict.selected_status
          this.selected_assigned = support_filters_dict.selected_assigned
          this.selected_category = support_filters_dict.selected_category
          this.selected_priority = support_filters_dict.selected_priority
          this.auto_reload = true
        }
      },
      async load_data() {

        this.loading = true
        try {
          const {value: {data = []}} = await search_support_tickets(this.selected_tenant, this.selected_assigned, this.selected_category, this.selected_priority, this.search_text, this.selected_status,
              moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
              moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
          )
          this.items = data
          this.items_full = data
          this.filter_results()
          this.save_filters()

        } catch (e) {
          this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
        }
        this.loading = false
      },
      async delete_support_ticket(tenant_id, id) {
        if (confirm("Are you sure you want to delete this ticket?")) {
          this.$emit('showAlert', "deleting ticket", 'info')
          const result = await delete_support_ticket(tenant_id, id)
          this.$emit('showAlert', "support ticket has been deleted", 'success', 5000)
          await this.load_data()
        }
      },
      async shift_detail_graph_date(shift) {
        this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY')
            .add(shift, 'months')
            .format('MM-DD-YYYY')
        this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY')
            .add(shift, 'months')
            .format('MM-DD-YYYY')
      },
      getOptionText(options, value) {
        const option = options.find(opt => opt.value === value)
        return option ? option.text : value
      },
      filter_results() {
        this.items = this.items_full
        if (this.search_text)
          this.items = this.items.filter(item => this.contains(item.username,this.search_text) || this.contains(item.subject,this.search_text) || this.contains(item.description,this.search_text) || this.contains(item.tenant_id,this.search_text))
      },
      contains(val1, val2) {
        if (val1 != null) {
          return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
        }
        return false;
      }
    },

    computed: {
      ...mapState({
        user: state => state.profile.user
      }),
      filteredFields() {
        return this.fields.filter(field => {
          if ((this.user.role !== 'admin' && this.user.tenant_options.length === 1) && field.key === 'tenant_id') {
            return false;
          }
          return true;
        })
      },
      search_tenant_options() {
        let options = [{value: '', text: 'All'}]
        return options.concat(this.user.tenant_options)
      },
      total_actual_hrs() {
        const billable_items = this.items.filter(item => item.actual_hours)

        return billable_items.reduce((accumulator, currentValue) => {
          return accumulator + Number(currentValue.actual_hours);
        }, 0);
      },
      estimated_hrs() {
        const billable_items = this.items.filter(item => item.estimated_hours)

        return billable_items.reduce((accumulator, currentValue) => {
          return accumulator + Number(currentValue.estimated_hours);
        }, 0);
      }
    },

    watch: {
      support_ticket: {
        deep: true,
        handler() {
          this.load_data()
        }
      },
      search_text() {
        this.filter_results()
      },
      selected_tenant(newDate) {
        if (this.auto_reload)
          this.load_data()
      },
      selected_category(newDate) {
        if (this.auto_reload)
          this.load_data()
      },
      selected_status(newDate) {
        if (this.auto_reload)
          this.load_data()
      },
      selected_assigned(newDate) {
        if (this.auto_reload)
          this.load_data()
      },
      selected_priority(newDate) {
        if (this.auto_reload)
          this.load_data()
      },
    }
  }
</script>

<style>
.error td {
  background-color: rgba(255, 0, 0, 0.25)
}

.success td {
  background-color: hsla(120, 100%, 75%, 0.3)
}

.unprocessed td {
  background-color: hsla(200, 40%, 80%, 0.3)
}

.cancelled td {
  background-color: hsla(290, 60%, 70%, 0.3)
}

div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem;
}

.list-text {
  text-align: left;
  margin-top: 7px;
  margin-left: 7px;
}

.list-option {
  text-align: left;
  margin: 2px;
}
</style>
